// src/features/payment/Payment.tsx
import React from "react";
import cash from "../../../../../assets/Images/1635d86b32b60583e7f022b9c3324b3d.png";
import late from "../../../../../assets/Images/5d48ac6d612c437a9078a93e10f21d9a.png";
import card from "../../../../../assets/Images/797fc01d4f9a82a498c18bd80db5608e.png";
import split from "../../../../../assets/Images/split.png";
import { usePaymentMethods } from "../hooks/usePaymentMethods";
import PaymentOption from "./components/PaymentOption";
import { ModalWrapper } from "../../../../../shared/components/ModalWrapper";
import CommonButtons from "../../../../../shared/components/CommonButtons";
import PayCash from "./PayCash";
import PayLater from "./PayLater";

interface Props {
  cartId: string | null;
  backHome: (value: string) => void;
  backHomepay: (value: string) => void;
  editedAmounts: { [productId: string]: string };
}

const Payment: React.FC<Props> = ({ cartId, backHome, backHomepay, editedAmounts }) => {
  const { openPayment, selectedMethod, selectMethod } = usePaymentMethods();

  // ✅ Map payment methods to their components
  const paymentComponents: Record<string, React.ReactNode> = {
    card: <PayCash cartId={cartId} backHome={backHome} backHomepay={backHomepay} type="Card" editedAmounts={editedAmounts} />,
    cash: <PayCash cartId={cartId} backHome={backHome} backHomepay={backHomepay} type="Cash" editedAmounts={editedAmounts} />,
    later: <PayLater cartId={cartId} backHome={backHome} backHomepay={backHomepay} type="Buy on Credit" editedAmounts={editedAmounts} />,
    split: <PayCash cartId={cartId} backHome={backHome} backHomepay={backHomepay} type="Split" editedAmounts={editedAmounts} />,
  };

  return (
    <ModalWrapper title="Choose Payment Method" onBack={() => backHomepay("onlyfalse")} showBackButton={true} onClose={() => backHomepay("onlyfalse")} className="min-w-[480px] text-center" width="max-w-xl w-full" >
      {openPayment ? (
        <div>{selectedMethod ? paymentComponents[selectedMethod] : null}</div>
      ) : (
        <div className="space-y-6">
          <div className="flex justify-end">
            <CommonButtons label="Add Product" onClick={() => backHome("false")} variant="primary" />
          </div>
          <div className="flex space-x-6 justify-center">
            <PaymentOption icon={late} label="Buy on credit" id="buy_on_credit_payment" onClick={() => selectMethod("later")} />
            <PaymentOption icon={card} label="Card" id="card_payment" onClick={() => selectMethod("card")} />
            <PaymentOption icon={cash} label="Cash" id="cash_payment" onClick={() => selectMethod("cash")} />
            <PaymentOption icon={split} label="Split" id="split_payment" onClick={() => selectMethod("split")} />
          </div>
        </div>
      )}
    </ModalWrapper>
  );
};

export default Payment;
